import * as m from '@/paraglide/messages'
import { locales } from '@/paraglide/runtime'

type Locale = (typeof locales)[number]

/**
 * Blanko-Bereiche der Vertragsdokumente (Punkt 193, Etappe 2, 22.09.2026):
 * Kaeufer und Bestellung als Tabellen, deren Werte auf der Seite leer bleiben
 * („ödeme adımında doldurulur"). Die Kette lib/kasa/sozlesme-belge.ts fuellt
 * jedes `data-belge-alan`-Feld beim Druck der PDF aus dem Kauf-Snapshot der
 * Order und entfernt den Hinweis `data-belge-not`. Ein Bauteil fuer beide
 * Dokumente (Ön Bilgilendirme Formu, Mesafeli Satış Sözleşmesi), damit die
 * Feldnamen an genau einer Stelle stehen; die Kette kennt dieselbe Liste
 * (BELGE_ALANLARI) und meldet ein fehlendes Feld als Klaerfall.
 */
const ALICI_ALANLARI = [
  ['alici', (l: Locale) => m.belge_alan_alici({}, { locale: l })],
  ['firma', (l: Locale) => m.belge_alan_firma({}, { locale: l })],
  ['vkn', (l: Locale) => m.belge_alan_vkn({}, { locale: l })],
  ['vergi_dairesi', (l: Locale) => m.belge_alan_vergi_dairesi({}, { locale: l })],
  ['adres', (l: Locale) => m.belge_alan_adres({}, { locale: l })],
  ['eposta', (l: Locale) => m.belge_alan_eposta({}, { locale: l })],
  ['telefon', (l: Locale) => m.belge_alan_telefon({}, { locale: l })],
] as const

const SIPARIS_ALANLARI = [
  ['siparis_no', (l: Locale) => m.belge_alan_siparis_no({}, { locale: l })],
  ['tarih', (l: Locale) => m.belge_alan_tarih({}, { locale: l })],
  ['urun', (l: Locale) => m.belge_alan_urun({}, { locale: l })],
  ['sure', (l: Locale) => m.belge_alan_sure({}, { locale: l })],
  ['bedel', (l: Locale) => m.belge_alan_bedel({}, { locale: l })],
  ['mahsup', (l: Locale) => m.belge_alan_mahsup({}, { locale: l })],
  ['odenen', (l: Locale) => m.belge_alan_odenen({}, { locale: l })],
  ['odeme_yontemi', (l: Locale) => m.belge_alan_odeme_yontemi({}, { locale: l })],
  ['onay_zamani', (l: Locale) => m.belge_alan_onay_zamani({}, { locale: l })],
  ['surumler', (l: Locale) => m.belge_alan_surumler({}, { locale: l })],
] as const

const tabloStyle = { width: '100%', borderCollapse: 'collapse', marginTop: 8 } as const
const thStyle = {
  textAlign: 'left',
  verticalAlign: 'top',
  width: '38%',
  padding: '6px 8px 6px 0',
  color: '#e5e1e4',
  fontWeight: 600,
  borderBottom: '1px solid rgba(255,255,255,0.08)',
} as const
const tdStyle = {
  verticalAlign: 'top',
  padding: '6px 0',
  borderBottom: '1px solid rgba(255,255,255,0.08)',
} as const
const bosStyle = { color: '#9a949c', fontStyle: 'italic' } as const
const baslikStyle = { fontSize: 15, margin: '18px 0 4px', color: '#e5e1e4' } as const

function Tablo({
  alanlar,
  locale,
}: {
  alanlar: ReadonlyArray<readonly [string, (l: Locale) => string]>
  locale: Locale
}) {
  return (
    <table style={tabloStyle} data-belge-tablo>
      <tbody>
        {alanlar.map(([alan, etiket]) => (
          <tr key={alan}>
            <th style={thStyle} scope="row">
              {etiket(locale)}
            </th>
            <td style={tdStyle} data-belge-alan={alan}>
              <span style={bosStyle}>{m.belge_alan_bos({}, { locale })}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export function BelgeAlanlari({ locale }: { locale: Locale }) {
  return (
    <>
      <p style={{ ...bosStyle, marginTop: 14 }} data-belge-not>
        {m.belge_alan_not({}, { locale })}
      </p>
      <h3 style={baslikStyle}>{m.belge_alici_baslik({}, { locale })}</h3>
      <Tablo alanlar={ALICI_ALANLARI} locale={locale} />
      <h3 style={baslikStyle}>{m.belge_siparis_baslik({}, { locale })}</h3>
      <Tablo alanlar={SIPARIS_ALANLARI} locale={locale} />
    </>
  )
}
